import React from 'react';
import { ComponentDivider,SelectDropdownStyles, CapsuleButtonWrapper } from '../styles';
import { Form, Row, Col} from 'antd';
import { CapsuleButton } from "../../../../../../../CommonComponents/Commons/commonComponents";
import PropTypes from "prop-types";
import { addMutualFund } from "../../../actions";
import { connect } from "react-redux";
import { withRouter } from 'react-router-dom';
import Notice from './Notice';
import { ContentContainerSpaceSmall} from "../../../styles";
import VanguardAccountNumber from "../../CommonComponents/InputComponent/VanguardAccountNumber";
import DropDownComponent from "../../CommonComponents/DropDownComponent/DropDown";
import {defaultWire} from "../../CommonComponents/Data";
import DonorDetails from "./DonorDetails";
import { recordError } from "../../../../../../../utils/commonUtil";
import { wireState } from "../../../selectors";

class Wire extends React.Component {
    constructor(props) {
        super(props);
        this.generateCheckData = this.generateCheckData.bind(this);
        this.addAnotherWire = this.addAnotherWire.bind(this);
        this.removeWire = this.removeWire.bind(this);
    }

    addAnotherWire = () => {
        try {
            let currentData = this.props.wireDetails;
            if (currentData.length < 20)
            {
            let data = JSON.parse(JSON.stringify(defaultWire[0]));
            let loggedInAddress = this.props.loggedInAddress;
                data.Donors[0] = loggedInAddress;
            currentData.push(data);
            this.props.addMutualAccount(currentData);
            }
        } catch (error) {
          recordError(error);
        }
    }

    removeWire = (index) => {
        try {
            let currentData = this.props.wireDetails;
            currentData.splice(index,1);
            this.props.addMutualAccount(currentData);
        } catch (error) {
          recordError(error);
        }
    }

    generateCheckData = (wires) => {
        let data = [];
        data = wires.map((wire, index) => {
            return(<>
                <Row>
                <Col lg={{span:8}} md={{span:8}}>
                        <SelectDropdownStyles>
                        <DropDownComponent assetHeld="wire" accountId={index} contributionType="wireList" label="Type of account in which assets are registered" traverse="corporateInformation" updateSelect="true" selected="wireSelected" giftLength={this.props.wireDetails.length-1}/>
                        </SelectDropdownStyles>
                    </Col>
                </Row>
                { (wire.type === "Other donor-advised fund") ?
                        <Row>
                            <Col>
                        <Notice message={this.props.pageDetails.wireNotice} />
                        </Col>
                        </Row>
                        : null
                    }
                { (wire.type !== "Select Account Type") ?
                        <Row>
                        <DonorDetails assetHeld="wire" accountId={index} contributionType="wireList" type={wire.type} count={this.props.wireDetails.length-1}/>
                        </Row>
                        : null
                    }
                <Row>
                <Col lg={{span:8}} md={{span:8}}>
                        <VanguardAccountNumber assetHeld="wire" selected="wireSelected" property="amount" label="Contribution amount" accountId={index} contributionType="wireList" giftLength={this.props.wireDetails.length-1}/>
                </Col>
                </Row>
                {(index !== 0) ?
                    <CapsuleButtonWrapper marginBottom="30px">
                    <CapsuleButton
                        text= "Remove Wire"
                        onClick={e => this.removeWire(index)}
                        id="btnRemoveWire"
                    />
                    </CapsuleButtonWrapper>
                    : null
                }
                {((index) < (wires.length-1)) ?
                    <ComponentDivider marginTop="0px" marginBottom="40px" mT="0px" mB="40px"/>
                    : null
                }
            </>)
        });
        return data;
    }

    render() {
        return (
            <ContentContainerSpaceSmall data-test="wrapper">
                <div className="fluid">
            <Form hideRequiredMark>
            
            <div className={this.props.isBlock !== 'none' ? 'block' : 'display-none' }>
                {this.generateCheckData(this.props.wireDetails)}
                        <CapsuleButtonWrapper marginBottom="30px">
                        <CapsuleButton
                            text= "Add another wire"
                            iconType="add"
                            padding="5px 20px"
                            disabled={this.props.wireDetails.length === 20 ? true : false}
                            onClick={e => this.addAnotherWire(e)}
                            id="btnAddAnotherWire"
                        />
                        </CapsuleButtonWrapper>
            </div>
            </Form>
            </div>
            </ContentContainerSpaceSmall>
        )
    }
}

const WrappedWire = Form.create({ name: "AssetHeldOutsideVanguard" })(Wire);

WrappedWire.propTypes = {
    wireDetails: PropTypes.array,
    loggedInAddress: PropTypes.object,
    pageDetails: PropTypes.object,
    addMutualAccount: PropTypes.func,
}

const mapStateToProps = state => ({
    ...wireState(state.toJS())
});

const mapDispatchToProps = dispatch => ({
    addMutualAccount: arr => dispatch(addMutualFund({value: arr, contributionType: "wireList", assetHeld:"wire", selected:'wireSelected'})),
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(WrappedWire));